const detectBrowser = () => {
    let userAgent = navigator.userAgent;
    let browserName;
    if (userAgent.match(/edg/i)) {
        browserName = "edge";
    } else if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "firefox";
    } else if (userAgent.match(/safari/i)) {
        browserName = "safari";
    } else if (userAgent.match(/opr\//i)) {
        browserName = "opera";
    } else {
        browserName = "No browser detection";
    }

    return browserName;
};

function detectOS() {
    let userAgent = navigator.userAgent;
    let osName;

    if (userAgent.match(/Windows/i)) {
        osName = "Windows";
    } else if (userAgent.match(/Macintosh/i)) {
        osName = "MacOS";
    } else if (userAgent.match(/Linux/i)) {
        osName = "Linux";
    } else if (userAgent.match(/Android/i)) {
        osName = "Android";
    } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
        osName = "iOS";
    } else {
        osName = "Unknown OS";
    }

    return osName;
}

function detectMobile() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        // /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

export { detectBrowser, detectMobile, detectOS };
